//
//
//
//
//
//
//

import {mapActions} from "vuex"
import requestApi from '@/api/request.js'

export default {
  name: 'app',
  data(){
    return {
      backbtn:false,
    }
  },
  watch:{
    $route(to,from){
      // console.log('APPjs');
      if(this.$route.query.ispc){//飞飞调用,存储是否显示返回按钮                
        this.$store.dispatch('backbtn',this.$route.query.ispc);
        this.backbtn=true;
      }
      if(this.$store.state.user.info&&this.$store.state.user.info.JudgeId){//是法官
        this.$store.dispatch('backbtn',false);
        this.backbtn=false;
      }
      if(this.$store.state.user.info&&this.$store.state.user.info.MemberSourceRemark=='手机版'){//是当事人
        this.$store.dispatch('backbtn',true);
        this.backbtn=true;
      }
      if(to.query.temp==from.path&&this.backbtn==true){//当前页和路由缓存一样,并且不是企业微信
        this.$route.query.temp='';
      }
      if(to.path == '/login' && from.path!='/'&& from.path!=''){
        let temp = {
          path:from.path,
          query:JSON.parse(JSON.stringify(from.query))
        }
        this.setOriginRoute(temp)
      }


    }
  },
  mounted() {
    //获取缓存的用户信息
    const info = window.localStorage.getItem('info') || '';
    if(info){
        console.log(this.$store)
      this.$store.dispatch('UserInfo',JSON.parse(info));
    }

  },
  methods:{
    ...mapActions("routes", ["setOriginRoute"]),
    
  },


}



// WEBPACK FOOTER //
// ./src/App.vue